import { render } from "./Crm.vue?vue&type=template&id=2ff77580"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Crm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ff77580"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ff77580', __exports__)) {
    api.reload('2ff77580', __exports__)
  }
  
  module.hot.accept("./Crm.vue?vue&type=template&id=2ff77580", () => {
    api.rerender('2ff77580', render)
  })

}


export default __exports__